import React from "react";
import { FormattedMessage } from "react-intl";
import { graphql } from "gatsby"

export const FrontendVersion = ({ version }) => (
  // <div>{"v" + data.site.siteMetadata.version}</div>
  <div role="contentinfo">
    © {(new Date()).getFullYear()} LEARNPULSE SAS - <FormattedMessage id="footer.copyrights" /> {`- v${version}` }
  </div>
);

export const query = graphql`
  fragment SiteVersionQuery on Site {
    siteMetadata {
      version
    }
  }
`;
 